import Form from './UpdateView';

export default Form;
